module.exports = __webpack_public_path__ + "img/icon-60.be328347.svg";